import { Map } from 'immutable'; 

const initialState = Map({
  "summaryTableSize":[1400,500],
  'showSummaryTable': false,
  'summaryTableData': Map(),
  'errorMessage': null
});

const TableApp = (state = initialState, action) => {

  switch(action.type){

    case "ERROR":
      return state.set('errorMessage', action.message);

    case "CLEAR_ERROR_MESSAGE":
      return state.set('errorMessage', null);

    case "RECEIVE_DATA":   
      return state.set('errorMessage', null);

    default:
      return state;
  }
}

export default TableApp;



// WEBPACK FOOTER //
// ./src/reducers/table.js